import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=6bbebbd2&scoped=true"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"
import style0 from "./PageNotFound.vue?vue&type=style&index=0&id=6bbebbd2&prod&scoped=true&lang=css"
import style1 from "./PageNotFound.vue?vue&type=style&index=1&id=6bbebbd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbebbd2",
  null
  
)

export default component.exports